import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_backer_center_project_recommendations_section = _resolveComponent("backer-center-project-recommendations-section")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createVNode(_component_empty_state, {
          title: _ctx.Resources.BackerCenter.UpdatesFeedEmptyStateHeader,
          description: _ctx.Resources.BackerCenter.UpdatesFeedEmptyStateParagraph,
          "data-qa": 'updates-feed-empty-state'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_button, {
              tag: "a",
              theme: "accent",
              href: $options.searchUrl,
              "data-qa": "updates-feed-empty-state:Reload"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.UpdatesFeedEmptyStateButtonLabel), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["href"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title", "description"])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_backer_center_project_recommendations_section, {
      "extra-large-screen-visible-items-count": 3,
      class: "_mt-6"
    })
  ]))
}